import { GetStaticPropsContext, NextPage } from 'next'
import Head from 'next/head'

import { initializeApollo, addApolloState } from '~/lib/apollo'
import {
  getServerPageGetAllNews,
  NewsOrderByInput,
  GetAllNewsQuery,
} from 'generated/graphql.api'
import NewsListTemplate from '~/components/templates/NewsListTemplate'

type Props = {
  data: GetAllNewsQuery
}

const NewsListPage: NextPage<Props> = ({ data }) => {
  return (
    <>
      <Head>
        <title>ニュース一覧 | eduad</title>
        <meta
          name='description'
          content='eduad-エデュアド-は教育・スクール運営に特化したウェブマーケティング支援を行うプロフェッショナル技術者集団です。最新ニュースをお届け。'
        />
      </Head>
      <NewsListTemplate data={data} />
    </>
  )
}

export const getStaticProps = async (
  ctx: GetStaticPropsContext,
  initialState
) => {
  const client = initializeApollo(initialState)
  const { props } = await getServerPageGetAllNews(
    { variables: { orderBy: NewsOrderByInput.DateDesc } },
    client
  )

  return addApolloState(client, {
    props: {
      data: props.data,
    },
    revalidate: 1,
  })
}

export default NewsListPage
